// i18n area 'networks' — locale sv-SE (task #171, onda 2): tradotto DALL'ITALIANO,
// che è la lingua SORGENTE (regola ratificata 2026-08-03); gli anglicismi del
// sorgente si TRASLANO, non si traducono. Sidecar anti-stantie: ../meta/networks.sv-SE.meta.json.
import type { enUS } from './networks'

export const svSE: typeof enUS = {
  networks: {
    common: {
      name: 'Namn',
      scope: 'Scope',
      operState: 'Status',
      actions: 'Åtgärder',
      create: 'Skapa',
      close: 'Stäng',
      cancel: 'Avbryt',
      delete: 'Ta bort',
      edit: 'Redigera',
      save: 'Spara',
      editError: 'Ändringen misslyckades',
      search: 'Sök på namn',
      empty: 'Ingenting här ännu',
      saveError: 'Kunde inte spara',
      loadError: 'Kunde inte läsa in — är TVirt-backenden nåbar?',
      createError: 'Skapandet misslyckades',
      deleteError: 'Borttagningen misslyckades',
      deleteConfirmTitle: 'Ta bort {name}?',
      deleteConfirmBody: 'Operationen går inte att ångra.',
      nameHint: 'Gemener, siffror och bindestreck (DNS-1123)',
      up: 'Aktiv',
      down: 'Inte aktiv',
      unknown: 'Okänd',
      usedByVMs: 'VM',
      emptyTable: 'Inga poster — lägg till en med knappen +'
    },
    dialogTabs: {
      general: 'Allmänt',
      base: 'Basdefinition',
      advanced: 'Avancerad konfiguration',
      reserved: 'Range reserverade för TVirt',
      position: 'Position',
      network: 'Nätverkskonfiguration',
      hosts: 'Deltagande noder'
    },
    reservedRanges: {
      note: 'Det här är de IP-range som är reserverade för TVirt och som plattformen kan använda för att automatiskt tilldela en adress till VM, containrar osv. OBS: IP-adresserna i de här rangen får inte användas utanför TVirt av externa tjänster/apparater.',
      from: 'Från',
      to: 'Till'
    },
    overlay: {
      title: 'Overlay-nätverk',
      createTitle: 'Skapa overlay-nätverk',
      editTitle: 'Redigera overlay-nätverk',
      vni: 'VNI',
      vniHint: 'VXLAN Network Identifier — tilldelas automatiskt om tomt',
      subnet: 'Subnät',
      subnetHint: 'Overlayets CIDR — IPAM härleder automatiskt dess registerpost',
      mtu: 'MTU',
      weight: 'Vikt',
      ceilMbps: 'Tak (Mbps)',
      fairnessHint: 'Vikten gäller bara vid konkurrens: på en ledig länk får varje nät använda hela bandbredden. Taket gäller däremot alltid.',
      contention: 'Konkurrens',
      contentionTip: 'Minst en nod observerar tapp eller overlimits MED kö på detta nätverks klass: uplinkens bandbredd är omstridd och vikterna verkar. Hur mycket och sedan när står i nodens net.shaping.*-serier.',
      firewallPolicy: 'Brandväggspolicy',
      hosts: 'Hostar',
      hostsTitle: 'Deltagande noder',
      hostsHint: 'Varje nod deklarerar sin underlay-endpoint — en select över nodens VERKLIGA adresser, lästa ur dess nätverkskonfiguration; den valfria overlay-adressen måste ligga i subnätet. Deltagandet är placement-villkoret.',
      hostNode: 'Nod',
      hostUnderlay: 'Underlay-IP',
      hostUnderlayPickNode: 'Välj noden först',
      hostAddress: 'Adress på overlayet (valfri)',
      hostAddressOutside: 'Utanför overlay-subnätet ({cidr})',
      addHost: 'Lägg till nod',
      observedAt: 'Observerat den',
      attachedNics: 'Anslutna NIC:ar'
    },
    services: {
      title: 'Nätverkstjänster',
      createTitle: 'Skapa nätverkstjänst',
      editTitle: 'Redigera nätverkstjänst',
      kind: 'Typ',
      kindCategory: 'Tjänster',
      selectKindHint: 'Välj typ av tjänst — den underliggande daemonen är en implementationsdetalj som TVirt hanterar åt dig.',
      kindLabel: {
        dhcp: 'DHCP-server',
        ntp: 'NTP-server',
        vpn: 'VPN-server',
        dns: 'DNS-server',
        gateway: 'Gateway',
        'lb-rp': 'Load balancer och reverse proxy',
        floatip: 'Flytande IP'
      },
      kindDesc: {
        dhcp: 'Tilldelar adresser på de betjänade subnäten — poolerna härleds från nätets subnät, gateway och TVirt-reserverade range.',
        dns: 'Auktoritativ DNS för de deklarerade zonerna — posterna härleds från IPAM plus dina manuella.',
        gateway: 'Noden agerar gateway för ett nätverk — NAT (DNAT, 1:1, SNAT/masquerade) plus statisk routing mellan de anslutna näten, självläkande by design.',
        'lb-rp': 'Lastbalanserare / omvänd proxy framför dina tjänster — L4- eller L7-lyssnare över pooler av medlemmar eller över en Pods redo instanser, omkonfigurerade under drift.',
        ntp: 'Nätverkens tidstjänst — relay av externa upstream-servrar, eller nodens klocka serverad till klienterna.',
        vpn: 'En VPN-koncentrator på noden — WireGuard eller OpenVPN, du väljer: fjärråtkomst för klienter på resande fot, eller en site to site-tunnel mellan två nät.',
        floatip: 'En adress som sitter på en enda frisk App-instans eller Pod i taget och flyttar till nästa friska mål när den faller — failover utan demoner; balanseringen stannar hos lastbalanseraren.'
      },

      // Round Pod nativi P4: l'IP flottante (4b) e il backend Pod dell'lb-rp (4a).
      floatip: {
        hint: 'Den flytande IP:n lever på det valda nätet som en EXTRA adress inne i hållarinstansens eget namnrymd: inga portar, ingen balansering, ingen NAT — klientens IP förblir äkta.',
        address: 'Flytande IP',
        targets: 'Mål',
        targetsHint: 'I PREFERENS-ordning: det första friska målet håller adressen. En Pod står för alla sina instanser, per replika; varje mål har sitt eget hälsokriterium. Varje mål måste vara anslutet till samma nät.',
        targetKind: 'Mål',
        targetApp: 'App-instans',
        targetPod: 'Pod (alla instanser)',
        targetRef: 'Vilken',
        health: 'Hälsa',
        healthRunning: 'Kör (varje container redo)',
        healthTcp: 'TCP-anslutning',
        healthHttp: 'HTTP GET',
        healthPing: 'Ping',
        port: 'Port',
        path: 'Sökväg',
        addTarget: 'Lägg till mål',
        moveUp: 'Flytta upp',
        moveDown: 'Flytta ned',
        preempt: 'Preempt',
        preemptHint: 'Av (standard): en frisk hållare behåller adressen även när ett högre mål kommer tillbaka — ingen flapping. På: det första friska målet håller den alltid.',
        holder: 'Hållare',
        noHolder: 'inget friskt mål',
        since: 'sedan',
        verdicts: 'Observerade mål',
        healthy: 'frisk',
        unhealthy: 'osund',
        noVerdict: 'Inte avgjort ännu — auktoritetsnoden skriver det första utslaget vid nästa genomgång.',
        vipChip: 'VIP {address}',
        vipChipTooltip: 'Denna instans håller den flytande IP:n {address} för tjänsten {service}'
      },
      poolSource: 'Slutpunkter',
      poolSourceMembers: 'Statiska medlemmar',
      poolSourcePod: 'En Pods redo instanser',
      poolBackendPod: 'Pod',
      poolBackendPort: 'Port',
      poolBackendHint: 'Slutpunkterna följer Podden: en instans går med när den kör med varje container redo och lämnar genast när den skalas ned eller dör. Den aktiva kontrollen är på som standard.',
      poolBackendCount: 'de redo instanserna av Pod {pod} på port {port}',
      node: 'Nod',
      enabled: 'Aktiverad',
      parked: 'Parkerad',
      subnets: 'Subnät',
      subnetsHint: 'IPAM-subnäten som den här instansen betjänar — poolerna härleds från CIDR, gateway och TVirt-reserverade range',
      noSubnets: 'Inget IPAM-subnät — deklarera först ett logiskt fabric-nätverk (eller ett overlay-subnät): IPAM härleds från dem',
      iface: 'Lyssningsgränssnitt',
      ifaceHint: 'Värdgränssnittet som tjänsten öppnar sin socket på (t.ex. en brygga) — obligatoriskt: en nätverkstjänst är självständig, "alla gränssnitt" finns inte längre',
      dns: 'DNS-servrar',
      domain: 'Domän',
      detail: 'Betjänar',
      subnetCount: '{n} subnät',
      zones: 'Zoner',
      zonesHint: 'Endast auktoritativ — daemonen rekurserar aldrig. A-posterna härleds från nodernas deklarerade adresser i de refererade IPAM-subnäten; reverse-switchen betjänar även motsvarande in-addr.arpa-zoner (PTR). En zon betjänas av högst en DNS-instans i flottan. Den valfria nameservern är det FQDN som skrivs i NS-/SOA-posterna i stället för standardens ns.<zon>; hamnar det inuti zonen härleds dess A-post ändå från den betjänande noden.',
      zoneName: 'Zonnamn',
      zoneNs: 'Nameserver (NS)',
      zoneSubnets: 'IPAM-subnät',
      zoneReverse: 'Reverse (PTR)',
      zoneRecords: 'Manuella poster',
      zoneRecordsHint: 'En per rad: namn TYP värde — typerna A, CNAME, MX, TXT. Vid namnkollision vinner den manuella posten över den härledda.',
      addZone: 'Lägg till zon',
      lbListeningHint: 'Instansen deklarerar ETT lyssningsnätverk och EN adress — varje lyssnare binder den på sin egen port; en andra adress är en andra tjänst.',
      listeners: 'Listeners',
      listenersHint: 'Varje lyssnare binder instansens adress på sin egen port i läge L4 (TCP-passthrough — byten öppnas aldrig) eller L7 (HTTP) och vidarebefordrar till en av poolerna nedan. Ett adress/port-par betjänas av högst en instans per nod. Ändringar gäller i farten — ingen omstart, inga förlorade anslutningar.',
      listenerName: 'Namn',
      listenerMode: 'Läge',
      modeL7: 'L7 — HTTP reverse proxy',
      modeL4: 'L4 — TCP-passthrough',
      listenerPort: 'Port',
      listenerPool: 'Pool',
      addListener: 'Lägg till listener',
      pools: 'Pooler',
      poolsHint: 'Backends där trafiken landar: statiska medlemmar balanserade round-robin eller efter minst belastad, med en valfri aktiv health check som tar sjuka medlemmar ur rotationen.',
      poolName: 'Namn',
      poolAlgorithm: 'Algoritm',
      algoRoundRobin: 'Round robin',
      algoLeastRequest: 'Minst belastad',
      poolCheck: 'Health check',
      checkNone: 'Ingen',
      checkTcp: 'TCP-anslutning',
      checkHttp: 'HTTP',
      poolCheckPath: 'Sondens sökväg',
      poolInterval: 'Intervall (s)',
      poolMembers: 'Medlemmar',
      poolMembersHint: 'En per rad: adress:port, valfritt följd av en vikt (1-128) — t.ex. 10.0.0.21:8080 2',
      addPool: 'Lägg till pool',
      memberCount: '{n} medlemmar',
      listen: {
        assignment: 'Tilldelning',
        assignmentStatic: 'Statisk adress',
        assignmentAuto: 'Automatisk (TVirt-reserverade intervall)',
        autoHint: 'TVirt drar adressen ur det logiska nätverkets reserverade intervall och håller den sticky — aldrig omdragen vid en redigering eller failover.',
        title: 'Lyssnare',
        hint: 'En nätverkstjänst är självständig: varje lyssnare deklarerar sitt nätverk (overlay, logiskt fabric-nätverk eller rått gränssnitt) och en adress inom dess subnät — en lyssnare per adress, jokertecknet finns inte längre. DNS och NTP får lyssna på flera nätverk och flera adresser i de nätverken.',
        address: 'Lyssningsadress',
        add: 'Lägg till lyssnare'
      },
      ntp: {
        mode: 'Synkroniseringsläge',
        modeRelay: 'Relay av externa servrar',
        modeNodeClock: 'Nodens klocka',
        modeHint: 'Relayn serverar tiden hämtad från de deklarerade upstream-servrarna; nodens klocka serverar den betjänande nodens tid — som klustret ändå håller synkroniserad',
        servers: 'Upstream-servrar',
        serversHint: 'Kommaseparerade — hostname eller IP-adress; tjänsten hämtar tiden härifrån och serverar den till nätet',
        port: 'Lyssningsport',
        listening: 'Lyssnar på'
      },
      vpn: {
        engine: 'Motor',
        engineHint: 'Du väljer den, och den ändras aldrig mer: WireGuard är modern, snabb och in-kernel; OpenVPN är kompatibilitetens veteran (TCP, fientliga nät)',
        engineLocked: 'Motorn är oföränderlig — en annan motor är en ny tjänst, nycklar och certifikat är inte portabla',
        mode: 'Läge',
        modeRemote: 'Fjärråtkomst',
        modeSite: 'Site to site',
        modeHint: 'Fjärråtkomsten ger klienter på resande fot en adress i tunneln; site to site förenar två nät',
        port: 'Lyssningsport',
        protocol: 'Transport',
        protocolWireguardHint: 'WireGuard talar bara UDP',
        tunnelSubnet: 'Tunnelns subnät',
        tunnelSubnetHint: 'Nätet där klienterna bor — registrerat i IPAM-registret, det föds och dör med den här tjänsten',
        dnsServers: 'DNS som pushas till klienterna',
        routes: 'Rutter som pushas till klienterna',
        routesHint: 'Kommaseparerade nät nåbara genom tunneln; tunnelns subnät är alltid inkluderat',
        peers: 'Peers',
        peersHint: 'Lämna den publika nyckeln tom så genererar TVirt paret — och levererar det sedan med profilen. Klistra in en nyckel så behåller peeren sin.',
        clients: 'Klienter',
        clientsHint: 'Varje klient får ett certifikat utfärdat av den här tjänstens CA. Att ta bort en klient ÅTERKALLAR den: CRL:en genereras om direkt.',
        peerName: 'Namn',
        publicKey: 'Publik nyckel',
        publicKeyMinted: 'TVirt genererar den',
        peerAddress: 'Adress i tunneln',
        peerAddressHint: 'Tomt = tilldelas',
        allowedIps: 'Fjärrsubnät',
        allowedIpsHint: 'Kommaseparerade, dirigerade genom den här peeren',
        endpoint: 'Endpoint',
        presharedKey: 'Fördelad nyckel',
        keepalive: 'Keepalive (s)',
        addPeer: 'Lägg till peer',
        addClient: 'Lägg till klient',
        auth: 'Autentisering',
        authTls: 'Certifikat (TLS)',
        remote: 'Fjärr-endpoint',
        remoteHint: 'host:port för den bortre änden — tomt betyder att den här sidan väntar',
        peerRoutes: 'Fjärrsubnät',
        serverPublicKey: 'Den här serverns publika nyckel',
        ca: 'Certifikatutfärdare',
        listening: 'Lyssnar på',
        tunnel: 'Tunnel',
        peerCount: '{n} peers',
        download: 'Ladda ner profil',
        downloadError: 'Profilen kunde inte exporteras',
        lastHandshake: 'Senaste handshake',
        never: 'aldrig',
        traffic: '↓ {rx} · ↑ {tx}',
        connected: 'Ansluten',
        idle: 'Inaktiv'
      },
      gateway: {
        attach: 'Typ av lyssningsnät',
        attachOverlay: 'Overlay-nätverk',
        attachNetwork: 'Logiskt fabric-nätverk',
        attachInterface: 'Rått gränssnitt',
        overlay: 'Overlay-nätverk',
        network: 'Logiskt nätverk',
        interface: 'Gränssnittets namn',
        interfaceHint: 'Ett host-gränssnitt som TVirt inte hanterar — adressen tas för god',
        address: 'Lyssningsadress (gateway)',
        addressHint: 'Gateway-adressen som klienterna pekar mot — inuti lyssningsnätets subnät',
        dnatTitle: 'DNAT-regler',
        dnatHint: 'Destinations-NAT: trafiken i matchen omdirigeras till en ny adress (och valfritt en ny port). Vilket protokoll som helst ur listan — portarna där protokollet bär dem.',
        snatTitle: 'SNAT-regler',
        snatHint: 'Käll-NAT: trafiken i matchen går ut med källan omskriven — en ny explicit adress (och valfritt en ny port), eller masquerade på utgångsadressen om det lämnas tomt.',
        oneToOneTitle: '1:1 NAT-regler',
        oneToOneHint: 'Varje paket till den externa adressen mappas till den interna, och den interna hosten går ut som den externa — alla protokoll, båda riktningarna.',
        external: 'Extern adress',
        internal: 'Intern adress',
        addOneToOne: 'Lägg till 1:1-regel',
        family: 'Familj',
        protocol: 'Protokoll',
        source: 'Källa (adress/subnät)',
        destination: 'Destination (adress/subnät)',
        invert: 'NOT',
        srcPorts: 'Källportar',
        dstPorts: 'Dest.-portar',
        dstPortsHint: 'Port eller range (80, 8000-8099)',
        toAddress: 'Ny adress',
        toPort: 'Ny port',
        snatTo: 'Ny källa (tomt = masquerade)',
        snatToHint: 'Explicit källadress; tomt = masquerade på utgångsadressen',
        addDnat: 'Lägg till DNAT-regel',
        addSnat: 'Lägg till SNAT-regel',
        routesTitle: 'Statiska rutter',
        routesHint: 'Noden dirigerar mellan näten den är ansluten till (IP forwarding är aktiv); de här rutterna lägger till nåbarhet utöver dem — ren kernel, dynamisk routing kommer i en senare runda.',
        routeDestination: 'Destinationssubnät',
        routeGateway: 'Next hop',
        routeMetric: 'Metrik',
        addRoute: 'Lägg till rutt',
        listening: 'Lyssnar på',
        rules: '{d} DNAT · {o} 1:1 · {s} SNAT · {r} rutter'
      },
      unknownSince: 'Okänd — senaste rapport för {m} min sedan',
      lastWord: 'Sista ordet',
      reportObservedAt: 'Senaste rapport',
      lastErrorRow: 'Senaste fel',
      recordsCount: '{n} manuella poster',
      phase: {
        configured: 'Konfigurerad',
        running: 'Kör',
        error: 'Fel'
      },
      authorityNode: 'Authority (tilldelning)',
      preferredNode: 'Föredragen nod',
      preferredNodeHint: 'En mjuk preferens, aldrig en begränsning: vid nästa placeringsbeslut landar instansen här om medlemmen är kvalificerad — på egen hand flyttar den ingenting; draget är "Överför authority".',
      noPreference: 'Ingen preferens (automatisk placering)',
      moving: 'I rörelse',
      movingTooltip: 'Observerad här medan authorityn tilldelar {node}: draget håller på att konvergera.',
      placement: {
        title: 'Placering',
        loading: 'Inventering pågår…',
        loadError: 'Placeringsinventeringen svarade inte — försök igen senare.',
        draftHint: 'Inventeringen beräknas på den deklarerade nätverksanslutningen: den dyker upp när tjänsten är skapad. Skapandet avvisas om ingen medlem kan betjäna den, och avslaget namnger den mekanism som tömde mängden.',
        eligibleCount: '{n} av {m} medlemmar kan betjäna den här instansen',
        recommended: 'Rekommenderad',
        eligible: 'Kvalificerad',
        notEligible: 'Inte kvalificerad',
        blockedReachability: 'nätverket når inte fram till den här medlemmen',
        blockedRequireTag: 'blockerad av en obligatorisk tagg (requireNodes)',
        blockedExcluded: 'utesluten av simuleringen',
        preferenceUnknown: 'är inte (längre) medlem i klustret',
        preferenceIgnored: 'Preferensen "{node}" är inte kvalificerad i dag: {reason}. Inventeringens rekommendation tar över — aldrig ett fel, tjänsten lever någon annanstans.',
        emptyReachability: 'Ingen medlem kan betjäna den här instansen: nätverket når ingenstans fram — ingen justering av taggar kommer att hjälpa. Dra kabel till noden, eller flytta tjänsten dit nätverket finns.',
        emptyRequireTag: 'Ingen medlem kan betjäna den här instansen: det är de obligatoriska taggarna som tömde mängden — ta bort posten från requireNodes, eller sätt taggen på en medlem.',
        spof: 'Single point of failure',
        spofDetail: 'Bara en enda medlem kan hysa instansen: vid fel har failovern ingenstans att ta vägen. En multi-listener-tjänst flyttar som en ENHET — kandidaten måste se ALLA dess nätverk: det är priset.',
        whatIf: 'Simulera frånvarande medlemmar',
        whatIfHint: 'Dräneringens what-if: fråga FÖRE evakueringen, upptäck det inte först vid failover.',
        survives: 'Med {nodes} frånvarande har tjänsten fortfarande ett hem.',
        notSurvives: 'Att evakuera {nodes} lämnar den här tjänsten NERE: den härledda begränsningen vinner över tillgängligheten (R30) — en daemon vid liv där nätverket inte når fram betjänar ingen och larmar ingen.',
        transfer: 'Överför authority',
        transferError: 'Överföringen misslyckades',
        transferTarget: 'Målmedlem',
        transferHint: 'Bara kvalificerade medlemmar erbjuds — en preferens inom den giltiga mängden, aldrig en override. Ingen task: workernas nästa varv ÄR draget (den gamla noden skördar, den nya reser).'
      }
    },
    fabric: {
      tabDerivation: 'Derivation',
      importNetwork: 'Importera från en annan fabric',
      importTitle: 'Importera ett logiskt nätverk',
      importHint: 'Importen är den uttryckliga anslutningen: nätverket förblir ägarens (samma identitet, samma stem, samma bridge tvf-<stem>) och härifrån mappas det på denna fabrics portar/LAGG — att mappa ÄR att hävda att leveransen mynnar i samma L2-domän som ägarens.',
      importPick: 'Ägarens nätverk',
      importNone: 'Inget att importera: de andra fabricarna har inget eget nätverk som denna fabric inte redan känner',
      importedNetworksTitle: 'Importerade nätverk',
      noImported: 'Inget importerat nätverk',
      importedFrom: 'importerat från {fabric}',
      importedBy: 'Importerat av: {list}',
      importedCount: '+{n} importerade',
      owner: 'Ägare',
      bridge: 'Bridge',
      bond: 'Bond',
      unimport: 'Ta bort import',
      unimportConfirm: 'Ta bort importen av nätverket {name} (ägare {fabric}) från denna fabric? Avvisas så länge en port eller ett LAGG i denna fabric mappar det, eller en gäst, App eller tjänst betjänas bara via detta ben.',
      unimportRefused: 'Importen används fortfarande — {detail}',
      deriv: {
        codeHint: {
          deviceHeldByFabric: 'Den här noden tar redan det nätverket från en annan fabric den är medlem i: en nod tar ett delat nätverk via ETT av sina ben (två uplinks på samma L2 i en bridge utan STP är en loop). Ta bort mappningen på portarna eller LAGG:et i en av de två fabricarna.',
          otherFabricDerived: 'Dokumentet bär blocket för en fabric som noden inte längre deklarerar någon kabel mot: tillämpa först den fabricens plan (den föreslår att dess enheter tas bort), eller ta över dem med take-ownership om fabricen är borta.'
        },
        hint: 'O.3-derivationsplanen: för varje kablad nod tillståndet, diffen härledd-vs-nuvarande, den DEKLARERADE bond-topologin, dual-stack-flipparna och de strukturerade avslagen/varningarna. Skrivskyddad tills den EXPLICITA applyn — inget landar någonsin av sig självt på en nod.',
        refresh: 'Ladda om planen',
        empty: 'Ingen nod är kablad till denna fabric (och ingen bär längre dess block).',
        refusal: 'Avslag',
        warning: 'Varning',
        generation: 'dokumentgeneration {n}',
        state: {
          manual: 'Manuell',
          derived: 'Härledd',
          diverged: 'Avvikande'
        },
        topologyTitle: 'Deklarerad topologi',
        members: 'medlemmar',
        primary: 'primär',
        held: 'hållen på ETT medlem',
        form: {
          perNetworkBond: 'Bond per nätverk',
          singleBond: 'Enkel fallback-bond',
          laggBond: 'LACP-bond (LAGG)',
          singlePort: 'Enkel port'
        },
        colAction: 'Åtgärd',
        colKind: 'Sort',
        colDevice: 'Device',
        colDetail: 'Detalj',
        action: {
          add: 'lägg till',
          remove: 'ta bort',
          replace: 'ersätt'
        },
        diffEmpty: 'Ingen väntande diff — det tillämpade dokumentet stämmer med rendern.',
        diffBlocked: 'Ingen diff: avslagen ovan blockerar denna nod.',
        phasePlanned: 'planerad (steg 1 av 3)',
        phaseDraining: 'dräneras (steg 2 av 3)',
        probeUnobserved: 'Drain-sond: aldrig rapporterad — tomheten är OKÄND (en retire skulle avslås nu).',
        probeFailed: 'Drain-sond: observationen MISSLYCKADES — de kända tidsstämplarna följer med, aldrig ett «tomt» ingen mätt.',
        probeActive: {
          one: 'Drain-sond: {n} etablerad anslutning kvar på den gamla adressen',
          other: 'Drain-sond: {n} etablerade anslutningar kvar på den gamla adressen'
        },
        probeLastActive: 'senaste aktivitet {time}',
        probeEmpty: {
          one: 'Drain-sond: tom i {n} minut',
          other: 'Drain-sond: tom i {n} minuter'
        },
        probeEmptyUnknown: 'Drain-sond: tom (sedan när är okänt).',
        impact: '{nics} vNIC och {apps} App på denna nod använder dessa nätverk: {list}',
        apply: 'Tillämpa på denna nod',
        applyTitle: 'Tillämpa derivationen — {node}',
        applyIntro: 'Den härledda konfigurationen skriver om nätverksdokumentet för {node} ({n} ändringar) genom samma dörr som host-network-editorn — NetworkManager-checkpoint och ärlig probe inkluderade. Planens varningar nedan följer med: läs dem innan du bekräftar.',
        applyError: 'Apply misslyckades',
        applyRefused: 'Noden avslog:',
        planMoved: 'Fabricen ändrades efter denna förhandsvisning — INGET tillämpades. Planen har laddats om: titta igen och försök på nytt.',
        retire: 'Avveckla',
        retireTitle: 'Point of no return — avveckling av {address}',
        restore: 'Återställ',
        restoreTip: 'Tillbaka till ögonblicksbilden före apply (generation {previous}) — ångra i ett steg (H13)',
        restoreTitle: 'Återställ föregående dokument — {node}',
        restoreIntro: 'Nätverksdokumentet för {node} går tillbaka till ögonblicksbilden tagen före senaste apply (generation {previous}), omskriven som generation {next} i stället för {current}. Workern konvergerar det som vilket annat dokument som helst.',
        restoreRedo: 'Det ersatta dokumentet blir den nya ögonblicksbilden: att återställa igen är redo.',
        restoreClosesChain: 'Ögonblicksbilden är det manuella dokumentet från före härledningen: kedjan stängs här — ingen mer ångra, noden är manuell till nästa apply.',
        restoreConfirm: 'Återställ',
        restoreError: 'Återställningen misslyckades',
        retireIntro: 'Detta tar bort {address} ({network}) från {point} för gott. Efter denna handling är vägen tillbaka den OMVÄNDA flippen — att deklarera om den gamla adressen genom samma motor — aldrig en blind återställning.',
        retireOld: 'Gammal adress (borttagen)',
        retireNew: 'Ny adress (stannar)',
        retireEmptyFact: 'Drain-sonden rapporterar adressen tom: denna borttagning bryter ingen observerad anslutning.',
        retireConfirm: 'Avveckla adressen',
        severActiveLoss: {
          one: 'Bryt {n} etablerad anslutning kvar på den gamla adressen — den dör med denna handling',
          other: 'Bryt {n} etablerade anslutningar kvar på den gamla adressen — de dör med denna handling'
        },
        severUnknownLoss: 'Acceptera det OKÄNDA: sonden har aldrig observerat denna adress (eller observationen misslyckas) — levande anslutningar kan brytas.'
      },
      title: 'Fabric',
      createTitle: 'Skapa fabric',
      networks: 'Nätverk',
      switches: 'Switchar',
      ports: 'Portar',
      laggs: 'LAGG',
      subnets: 'Subnät',
      tabOverview: 'Översikt',
      tabNetworks: 'Logiska nätverk',
      tabSwitches: 'Switchar',
      overviewHint: 'Fabricen i ett ögonkast: varje logiskt nätverk med MTU och subnät (VLAN bor bara i mappningarna per port/per LAGG — samma nät kan färdas med olika taggar på olika portar). Fabricen är registret över en EXTERN infrastruktur — TVirt observerar och deklarerar, gör aldrig provisioning, och rör bara NIC:ar registrerade under dess kontroll.',
      absorptionHint: 'Varje subnät som deklareras här HÄRLEDER sin post i IPAM-registret i samma skrivning — det lever och dör med nätverket.',
      scopeFixedHint: 'Scope är fast: klustrets rot — fysisk infrastruktur är per definition klusteromfattande.',
      networksHint: 'Varje nätverk bär en obligatorisk MTU (standard 1500) och ett obligatoriskt subnät; gateway, DNS-servrar och statiska rutter deklarerade här är den ENDA KÄLLAN för servrarnas NIC:ar, appar och nätverkstjänster.',
      switchesHint: 'Det manuella registret: en port är oanvänd, mappad (untagged trafik och per VLAN-tagg på de logiska nätverken) eller medlem i en LAGG — en medlem bär inga egna mappningar.',
      mtu: 'MTU',
      cidr: 'CIDR',
      cidrHint: 'Obligatorisk — IPAM härleder automatiskt dess registerpost',
      nodeAddressing: 'Nodadressering',
      nodeAddressingNone: 'Ingen — ingen adress per nod',
      nodeAddressingPool: 'Pool — en fast adress per betjänad nod',
      nodeAddressingHint: 'Med Pool tilldelar fabric-härledningen varje betjänad nod en adress ur de områden som reserverats för TVirt (fast när den tilldelats).',
      backing: 'Backing',
      gateway: 'Gateway',
      ranges: 'Reserverade range',
      dns: 'DNS-servrar (kommaseparerade)',
      dnsShort: 'DNS',
      singleSourceHint: 'Gateway, DNS och rutter deklarerade här är den enda källan — servrarnas NIC:ar, appar och nätverkstjänster hämtar härifrån',
      routesTitle: 'Statiska rutter',
      routeDestination: 'Destination (CIDR)',
      routeVia: 'Via (next hop)',
      portUsed: 'Använd',
      vlanMappings: 'VLAN-mappningar',
      vlanTag: 'VLAN-tagg',
      vlanNetwork: 'Logiskt nätverk',
      nameTaken: 'Namnet är redan använt i fabricen',
      addNetwork: 'Lägg till nätverk',
      editNetwork: 'Redigera nätverk',
      deleteNetwork: 'Ta bort nätverk',
      deleteNetworkConfirm: 'Ta bort det logiska nätverket {name} från fabricen? Dess härledda subnät i IPAM dör med det (avvisas så länge en tjänst eller en app använder det). Port- och LAGG-mappningar som pekar på det rensas.',
      switchName: 'Switch',
      portName: 'Port',
      positionHint: 'Fysisk position (valfri) — samma vokabulär som serverplaceringen; enbart deklarativ',
      addSwitch: 'Lägg till switch',
      editSwitch: 'Redigera switch',
      deleteSwitch: 'Ta bort switch',
      deleteSwitchConfirm: 'Ta bort switchen {name} med alla dess portar? LAGG:arna krymper i motsvarande grad (och dör under två portar).',
      addPort: 'Lägg till port',
      editPort: 'Redigera port',
      deletePort: 'Ta bort port',
      deletePortConfirm: 'Ta bort porten {name}?',
      untagged: 'Untagged',
      tagged: 'Tagged (tagg:nätverk)',
      taggedShort: 'Tagged',
      portCabling: 'Kablage',
      portState: 'Status',
      stateUnused: 'oanvänd',
      stateMapped: 'mappad',
      laggPortGuard: 'En port som är medlem i en LAGG ändras från LAGG-sidan',
      laggsTitle: 'LAGG',
      laggsHint: 'En LAGG är 2+ portar i LACP och kan korsa switchar (MLAG, transparent); bara oanvända portar går in, LAGG:en är mappningsytan, en borttagen port blir åter oanvänd.',
      addLagg: 'Lägg till LAGG',
      editLagg: 'Redigera LAGG',
      deleteLagg: 'Ta bort LAGG',
      deleteLaggConfirm: 'Ta bort LAGG:en {name}? Dess medlemsportar blir åter oanvända.',
      lacpRate: 'LACP-rate',
      laggPorts: 'Medlemsportar (2+)',
      laggPortsHint: 'Bara oanvända portar går in — frigör en mappad port först',
      noNetworks: 'Inget logiskt nätverk deklarerat.',
      noSwitches: 'Ingen switch deklarerad.',
      noLaggs: 'Ingen LAGG deklarerad.',
      staleConflict: 'En annan operatör har ändrat den här fabricen medan du redigerade den: sparandet avvisades för att inte radera hens arbete. Dina ändringar finns kvar här, orörda. Den uppdaterade fabricen har redan laddats om: bekräfta igen för att lägga dem ovanpå, eller avbryt och se vad som ändrats.'
    },
    ipam: {
      title: 'IPAM',
      derivedHint: 'Enbart härlett: varje subnät föds ur ett logiskt fabric-nätverk eller ett overlay — det ändras vid källan. De tilldelade adresserna visar VEM som håller dem; de TVirt-reserverade rangen är den automatiska tilldelningens pooler.',
      search: 'Sök på namn, CIDR eller adress',
      empty: 'Inget nätverk — deklarera ett logiskt fabric-nätverk eller ett overlay-subnät: IPAM härleds från dem automatiskt.',
      reserved: 'Range reserverade för TVirt',
      address: 'Adress',
      origin: 'Ursprung',
      origin_declared: 'deklarerad',
      origin_observed: 'observerad',
      holder: 'Hålls av',
      noAddresses: 'Ingen känd adress i det här subnätet.',
      sourceFabric: 'Fabric',
      sourceOverlay: 'Overlay',
      editAtSource: 'Redigera vid källan'
    },

    // Rete > Firewall (#168): il vocabolario dei gruppi + la terna per-NIC.
    firewall: {
      title: 'Brandväggsgrupper',
      createTitle: 'Ny brandväggsgrupp',
      editTitle: 'Redigera brandväggsgrupp',
      empty: 'Inga brandväggsgrupper ännu — skapa en: en återanvändbar vokabulär av regler, refererad från guest-NIC:arna vid namn.',
      nameHint: 'Bokstäver, siffror och inre . - _; unikt inom sitt scope (namnar på andra håll särskiljs med /scope/namn)',
      description: 'Beskrivning',
      descriptionHint: 'En rad om avsikten, visad överallt där gruppen väljs',
      enforced: 'Framtvingad på scopet',
      enforcedHint: 'Av: ren vokabulär — reglerna binder bara de NIC som refererar gruppen. På: reglerna binder varje guest-NIC med påslagen brandvägg under gruppens scope, refererad eller ej.',
      enforcedChip: 'Framtvingad',
      enforcedChipHint: 'Reglerna binder varje guest-NIC med påslagen brandvägg under gruppens scope, refererad eller ej',
      enforceWarning: 'Slås framtvingandet på binder reglerna VARJE guest-NIC med påslagen brandvägg under {scope} vid nästa konvergens, även utan explicit referens — och inuti en aktiv chain är en förfaders drop slutgiltig: nivåerna under kan inte öppna det igen.',
      unenforceInfo: 'Tas framtvingandet bort stannar reglerna bara på de NIC som refererar gruppen explicit.',
      rules: 'Regler',
      tabOverview: 'Översikt',
      tabRules: 'Regler',
      orderHint: 'Radernas ordning ÄR evalueringsordningen inom gruppen: den första regel som matchar vinner.',
      statefulHint: 'Stateful är implicit: svaren på tillåten trafik passerar av sig själva (established/related accepteras, invalid kastas — injicerade av motorn, aldrig skrivna för hand).',
      noRules: 'Inga regler — en vokabulär under uppbyggnad: att referera den är tillåtet och renderar ingenting.',
      addRule: 'Lägg till regel',
      direction: 'Riktning',
      directionIn: 'Inkommande',
      directionOut: 'Utgående',
      action: 'Åtgärd',
      action_accept: 'Acceptera',
      action_drop: 'Kasta',
      action_reject: 'Avvisa',
      protocol: 'Protokoll',
      protocolAny: 'Vilket som helst',
      ports: 'Portar',
      source: 'Källa',
      dest: 'Destination',
      comment: 'Kommentar',
      addressHint: 'IPv4-CIDR eller <fabric>/<logiskt nätverk>; tomt = vilken som helst',
      moveUp: 'Flytta upp',
      moveDown: 'Flytta ned',
      nicFirewall: 'Brandvägg',
      nicAntiSpoof: 'Anti-spoofing',
      nicGroups: 'Brandväggsgrupper',
      nicGroupsPlaceholder: 'Välj en grupp…',
      nicGroupsHint: 'De synliga grupperna, inklusive dem från överordnade scopes (användbara nedåt, som taggar)',
      nicGroupCount: { one: '{n} brandväggsgrupp', other: '{n} brandväggsgrupper' },
      nicOff: 'Brandvägg av',
      pendingRestartHint: 'Brandväggsändringar följer den sparade/tillämpade modellen: de väntar på nästa power cycle (PendingRestart). Grupper framtvingade av överordnade scopes tillämpas när NIC:ns brandvägg är påslagen.',
      appConvergeHint: 'Brandväggsändringar tillämpas vid containerns nästa konvergens. Grupper framtvingade av överordnade scopes tillämpas när brandväggen är påslagen.',
      enforcedAncestors: 'Framtvingade av överordnade scopes',
      enforcedAncestorsHint: 'Den här gruppen tillämpas på varje NIC under sitt scope vars brandvägg är PÅ — reglaget är NIC:ns huvudströmbrytare (av = ingen chain alls, förfäder inräknade); inuti en aktiv chain är förfaderns auktoritet slutgiltig: dess drop öppnas inte igen nedanför.'
    }
  }
}
